
import React from 'react';
// functions
import { decimalOrBust } from '../../utilities/currency';

// components
import BasketItem from './BasketItem';
import { TransactionHistory } from './TransactionHystory';


function Basket({ items = [], total, deposit, balance = 0, orderIdx }) {
  const deliveryItem = items.find(item => item.product.toUpperCase().includes('HOME DELIVERY') || item.catNo === '486-79618' || item.catNo === '486-79622');
  const deliveryCharge = deliveryItem ? deliveryItem.value : 0;
  const PRODUCT_TYPE_PRECEDENCE = ['UP', 'FS', 'CB', 'VA'];

  // stack sofaglides for now
  const sofaglides = items.filter(item => item.productTypeLineType === 'CS')
  const sgLookup = sofaglides.reduce((stacked, curr) => {
    const stack = { ...stacked };
    if (stack[curr.catNo]) {
      stack[curr.catNo].value += curr.value;
    }
    else {
      stack[curr.catNo] = curr;
      stack[curr.catNo].imageUrl = 'https://images.sofology.co.uk/image/upload/v1563263370/Checkout/Sofaglide_small.png';
    }
    stack[curr.catNo].qty = 1; // hide quantity
    return stack;
  }, {});

  items = items.filter(item => item.productTypeLineType !== 'CS');
  items = items.concat(Object.keys(sgLookup).map(key => sgLookup[key]));


  const sortedItems = items.sort((a, b) => {
    const aIndex = PRODUCT_TYPE_PRECEDENCE.indexOf(a.productTypeLineType);
    const bIndex = PRODUCT_TYPE_PRECEDENCE.indexOf(b.productTypeLineType);
    if (aIndex === -1 && bIndex === -1) return 0;
    if (aIndex === -1) return 1;
    if (bIndex === -1) return -1;
    return aIndex - bIndex;
  });

  // add basket item values to total
  const basketAddonsValue = items.reduce((acc, curr) =>
    curr.itemType === 'basket' ? acc + curr.value : acc, 0);

  const totalWithAddons = total + basketAddonsValue;
  const balanceWithAddons = balance + basketAddonsValue;
  // set minimum outstanding balance
  // This has been done as a workaround for delivery surcharges not being correctly updated
  // and will require a change once this has been updated or if issues with refund come up.
  const outStandingBalance = balanceWithAddons < 0 ? 0 : balanceWithAddons;

  const basketItems = sortedItems.length ? sortedItems.filter(x => x.productTypeLineType !== 'VS') : [];
  const paymentItems = sortedItems.length ? sortedItems.filter(x => x.productTypeLineType === 'VS') : [];

  return (
    <ul className="basket u-padding-top-small u-padding-x-small u-padding-bottom-small">
      {
        basketItems.map((item, i) => <BasketItem item={item} key={`os-basket-item-${i}-${item.code}`} orderIdx={orderIdx} />)
      }
      <TransactionHistory transactions={paymentItems} />
      <PriceRow rowClass="u-padding-top-small" item={'Delivery'} value={`£${decimalOrBust(deliveryCharge)}`} />
      <PriceRow item={'Total'} value={`£${decimalOrBust(totalWithAddons)}`} />
      <PriceRow item={'Deposit(s)'} value={`£${decimalOrBust(deposit)}`} />
      <PriceRow item={'Outstanding balance:'} value={`£${decimalOrBust(outStandingBalance)}`} />

    </ul>
  );
}

function PriceRow({ item, value, bold = false, rowClass = '' }) {
  return (
    <li className={`price__row__overide ${rowClass}`}>
      <div className="basket__item price-row">
        {item}
      </div>
      <div className={'basket__value u-padding-left-small'}>
        {bold ? <strong>{value}</strong> : value}
      </div>
    </li>
  );
}

export default Basket;



// WEBPACK FOOTER //
// ./src/parts/Basket/index.js